import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {Field, reduxForm, getFormValues} from 'redux-form';
import {HttpStatusCode} from 'axios';
import {isEmpty} from '@grapecity/wijmo';

import {withStyles} from '@mui/styles';
import Grid from '@mui/material/Grid';
import Divider from '@mui/material/Divider';
import SearchIcon from '@mui/icons-material/Search';
import RotateLeftIcon from '@mui/icons-material/RotateLeft';
import {CATEGORY_TYPE, GMN, GMN_PATH, STEP_APPROVAL} from '../../../../common/commonConst.js';
import {commonOperations} from '../../../../reducks/common';
import MainContainer from '../../../organisms/MainContainer.js';
import {renderTextField, renderSelect, renderCheckbox, renderSelectMultiLine} from '../../../atoms/CustomPart.js';
import CustomFlexGrid, {createComponents} from '../../../molecules/CustomFlexGrid.js';
import {PositiveButton} from '../../../atoms/Buttons/PositiveButton.js';
import NegativeButton from '../../../atoms/Buttons/NegativeButton.js';
import * as validateRule from '../../../validateRule.js';
import PaperPart from '../../../atoms/PaperPart.js';
import withRouter from '../../../organisms/withRouter.js';
import {setSessionObject} from '../../../../common/Session.js';
import WarningMessageArea from '../../../molecules/WarningMessageArea.js';
import ApprovalStatus from '../../../organisms/Approval/ApprovalStatus/index.js';
import {
  FormControl,
  FormGroup,
} from '@mui/material';
import CustomAccordion from '../../../molecules/Accordion.js';
import CustomBreadcrumbs from '../../../molecules/Breadcrumbs.js';
import {createDataMap, getKbnList, sysErr} from '../../../../common/commonGmn.js';
import {getNewNwOfficeMap, searchCheck, searchMap} from '../../../../common/common.js';
import {postRequest} from '../../../../common/backend.js';
import {validate} from '../../../formValidate.js';

// パンくずパラメータ
const transitionList = [
  {gmnName: GMN.MENU.name, href: GMN_PATH.MENU},
  {gmnName: GMN.APPLICATION_APPROVAL_LIST.name, href: ''},
];

// 承認一覧Items
const gridItems = [
  {binding: 'approvalRecordType', header: '承認区分', dataType: 'String', dataMap: null, width: 180},
  {binding: 'appInfoNo', header: '対象番号', dataType: 'link', width: 150},
  {binding: 'stepApprovalDesp', header: '承認ステータス', dataType: 'link', width: 150},
  {binding: 'registerUser', header: '申請者', dataType: 'String', width: 120},
  {binding: 'registerDateTime', header: '申請日', dataType: 'String', width: 120},
  {binding: 'approvalUser', header: '承認者', dataType: 'String', width: 120},
  {binding: 'approvalDateTime', header: '承認日', dataType: 'String', width: 120},
  {binding: 'approvalComment', header: '承認コメント', dataType: 'String', width: 150},
  {binding: 'surveyCompanyCode', header: '調査会社', dataType: 'String', dataMap: null, width: 150},
  {binding: 'nwOfficeCode', header: 'NW事業所', dataType: 'String', dataMap: null, width: 150},
  {binding: 'surveyAgencyOfficeCode', header: '調査機関事業所', dataType: 'String', dataMap: null, width: 150},
];

/**
 *  承認一覧画面
 * 画面ID:SCZ1005
 */
class Container extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      buttonDisabled: true,
      warningMessages: [],
      ApprovalFlag: true,
      showApprovalModal: false,
      appInfoNoList: [],
    };

    this.gridRef = React.createRef();
    this.setGmnItems();
    this.setGridItems();
  }

  /**
   * 画面項目設定
   */
  setGmnItems = () => {
    const {
      genericMap,
      userInfo,
    } = this.props;

    // 承認区分
    const approvalRecordTypeMap = searchMap(
        genericMap, CATEGORY_TYPE.APPROVAL_RECORD_TYPE);
    this.approvalRecordTypeList = getKbnList(approvalRecordTypeMap);

    // 承認ステータス
    const stepApprovalMap = searchMap(
        genericMap, CATEGORY_TYPE.STEP_APPROVAL);
    let filterdStepApprovalMap = stepApprovalMap
        .filter((item) => item.cd !== STEP_APPROVAL.WAIT_APPROVAL);
    this.stepApprovalList = getKbnList(filterdStepApprovalMap);

    // 調査会社
    const surveyCompanyCodeMap = searchMap(
        genericMap, CATEGORY_TYPE.CORP_CD);
    this.surveyCompanyCodeList = getKbnList(surveyCompanyCodeMap);

    // NW事業所
    const newNwOfficeMap = getNewNwOfficeMap(
        genericMap, userInfo.authNwOfficeCodes);
    this.nwOfficeList = getKbnList(newNwOfficeMap);

    // 調査機関事業所
    const surveyAgencyOfficeCodeMap = searchMap(
        genericMap, CATEGORY_TYPE.SURVEY_AGENCY_OFFICE_CODE);
    let surveyAgencyOfficeCodes = surveyAgencyOfficeCodeMap.filter(
        (item) => userInfo.authSurveyAgencyOfficeCodes.includes(item.cd));
    this.surveyAgencyOfficeCodeList = getKbnList(surveyAgencyOfficeCodes);
  };

  /**
   * 画面一覧項目設定
   */
  setGridItems = () => {
    const {genericMap} = this.props;

    let views = gridItems;
    views.forEach((view) => {
      switch (view.binding) {
        case 'approvalRecordType':
          view.dataMap = createDataMap(
              genericMap, CATEGORY_TYPE.APPROVAL_RECORD_TYPE);
          break;
        case 'appInfoNo':
          view.click = (e, ctx) => {
            this.doEditLink(ctx.item.approvalRecordType, ctx.item.appInfoNo,
                ctx.item.nwOfficeCode, ctx.item.surveyCompanyCode);
          };
          break;
        case 'stepApprovalDesp':
          view.click = (e, ctx) => {
            this.displayApproval(ctx);
          };
          break;
        case 'surveyCompanyCode':
          view.dataMap = createDataMap(
              genericMap, CATEGORY_TYPE.CORP_CD);
          break;
        case 'nwOfficeCode':
          view.dataMap = createDataMap(
              genericMap, CATEGORY_TYPE.NW_OFFICE_CODE);
          break;
        case 'surveyAgencyOfficeCode':
          view.dataMap = createDataMap(
              genericMap, CATEGORY_TYPE.SURVEY_AGENCY_OFFICE_CODE);
          break;

        default:
          break;
      }
    });
  };

  /**
   * 初期処理
   */
  async componentDidMount() {
    await this._initialValue();
    this.doSearch();
  }

  /**
   * 画面項目初期化
   */
  _initialValue = async () => {
    const {userInfo} = this.props;
    try {
      const values = {
        surveyCompanyCode: userInfo.corpCd,
        nwOfficeCode: userInfo.nwOfficeCode,
        surveyAgencyOfficeCode: userInfo.surveyAgencyOfficeCode,
        waitSelfApproval: true,
        stepApproval: [STEP_APPROVAL.NEXT_APPROVAL],
      };
      await this.props.doSetInitValues(values);
    } catch (error) {
      sysErr(this.props);
    }
  };

  /**
   * 終了処理
   */
  async componentWillUnmount() {
    this.props.reset();
    this.props.doSetInitValues(null);
  }

  /**
   * クリア処理
   */
  _reset = async () => {
    await this.props.reset();
    this._initialValue();
    this.gridRef.current.setItemsSource([]);
  };

  /**
   * 検索ボタン押下時処理
   * @param {bool} show
   */
  doSearch = async () => {
    const {userInfo, values} = this.props;
    let _warningMessages = [];
    try {
      let _body = {
        searchConditionModel: values,
        corpCodes: isEmpty(values.surveyCompanyCode) ?
          userInfo.authCorpCodes : Array.of(values.surveyCompanyCode),
        nwOfficeCodes: isEmpty(values.nwOfficeCode) ?
          userInfo.authNwOfficeCodes : Array.of(values.nwOfficeCode),
        surveyAgencyOfficeCodes: isEmpty(values.surveyAgencyOfficeCode) ?
          [] : Array.of(values.surveyAgencyOfficeCode), // Ⅱ期対応 TODO
      };

      // リクエスト出す
      let _url = 'scz1005/search-approval-list';
      const response = await postRequest(_url, _body);
      if (response.status != HttpStatusCode.Ok) {
        if (response.data?.message != null) {
          this.props.doShowMessage({
            message: {id: response.data?.message.id,
              text: response.data?.message.text},
          });
        } else {
          this.props.doShowMessage({
            message: {id: 'TKSCS00011E', values: ['承認一覧', '検索']},
          });
        }
        return;
      }
      let approvalList = response.data.approvalList || [];
      _warningMessages = searchCheck(approvalList);
      if (this.gridRef?.current) {
        this.gridRef.current.setItemsSource(approvalList);
      }
    } catch (error) {
      sysErr(this.props);
    } finally {
      this.setState({
        warningMessages: _warningMessages,
      });
    }
  };

  /**
   * チェックボックスのイベント
   * @param {*} event
   */
  _handleChangeCheckboxApproval = (event) => {
    console.log(event.target.value);
    if (!event.target.checked) {
      this.setState({
        ApprovalFlag: false,
      });
    } else {
      this.setState({
        ApprovalFlag: true,
      });
    }
  };

  /**
   * 一覧表示
   * @return {object}
   */
  renderTable() {
    const props = {
      rowHeaderType: 'None',
      filterOn: true,
      headersVisibility: 'Column',
      allowSorting: 'SingleColumn',
      AddDeleteOn: false,
      style: {maxHeight: '300pt', maxWidth: '100%', height: 'auto', width: 'auto'},
      isReadOnly: true,
      isDisplayCount: true,
    };

    let views = gridItems;
    const component = createComponents(views, true);
    return (
      <CustomFlexGrid ref={this.gridRef} {...props}>
        {component}
      </CustomFlexGrid>
    );
  }

  /**
   * 一承認状況リック時
   * @param {*} approvalRecordType 承認区分
   * @param {*} appInfoNo 申請対象番号
   * @param {*} nwOfficeCode NW事業所コード
   * @param {*} surveyCompanyCode 会社コード
   */
  doEditLink = async (approvalRecordType, appInfoNo,
      nwOfficeCode, surveyCompanyCode) => {
    try {
      let params = {
        orderNo: appInfoNo,
        nwOfficeCode: nwOfficeCode,
        surveyCompanyCode: surveyCompanyCode,
        transitionList: transitionList,
      };

      params.transitionList[1].href = GMN_PATH.APPLICATION_APPROVAL_LIST;

      switch (approvalRecordType) {
        case 'IY':
          // 調査年度・委託エリア入力票画面に遷移
          setSessionObject(GMN.SURVEY_YEAR_COMPANY_INFO.id, params);
          this.props.navigate(GMN_PATH.SURVEY_YEAR_COMPANY_INFO);
          break;
        case 'IB':
          // 調査業種入力票画面に遷移
          setSessionObject(GMN.SURVEY_INDUSTRY_INFO.id, params);
          this.props.navigate(GMN_PATH.SURVEY_INDUSTRY_INFO);
          break;
        case 'IR':
          // 調査理由入力票画面に遷移
          setSessionObject(GMN.SURVEY_REASON_INFO.id, params);
          this.props.navigate(GMN_PATH.SURVEY_REASON_INFO);
          break;
        case 'FW':
          // 全使撤入力票画面に遷移
          setSessionObject(GMN.ZENSITETU_INFO.id, params);
          this.props.navigate(GMN_PATH.ZENSITETU_INFO);
          break;
        case 'SA':
          // 調査点検箇所追加交付入力票画面に遷移
          setSessionObject(GMN.TSTK_KASYO_MANAGE_INFO.id, params);
          this.props.navigate(GMN_PATH.TSTK_KASYO_MANAGE_INFO);
          break;
        case 'IM':
          // お客さま個別管理入力票画面に遷移
          setSessionObject(GMN.CUSTOMER_INDIVIDUAL_MANAGE_INFO.id, params);
          this.props.navigate(GMN_PATH.CUSTOMER_INDIVIDUAL_MANAGE_INFO);
          break;
        case 'YP':
          // 年度計画入力票画面に遷移
          setSessionObject(GMN.ANNUAL_SURVERY_PLAN_LIST.id, params);
          this.props.navigate(GMN_PATH.ANNUAL_SURVERY_PLAN_LIST);
          break;
        case 'IS':
          // 委託エリア設定入力票画面に遷移
          setSessionObject(GMN.GOAL_INVEST_SETTING_MESH.id, params);
          this.props.navigate(GMN_PATH.GOAL_INVEST_SETTING_MESH);
          break;
        default:
          break;
      }
    } catch (error) {
      sysErr(this.props);
    }
  };

  /**
   * 承認状況画面の表示
   * @param {*} ctx 一覧項目
   */
  displayApproval = (ctx) => {
    let appInfoNoList = [];
    if (ctx.item.appInfoNo) {
      appInfoNoList = Array.of(ctx.item.appInfoNo);
    }
    this.setState({
      showApprovalModal: true,
      appInfoNoList: appInfoNoList,
    });
  };

  /**
   * 承認状況画面画面を閉じる
   */
  closeApproval = () => {
    this.setState({
      showApprovalModal: false,
      appInfoNoList: [],
    });
  };

  /**
   * 検索条件タブの要素生成
   * @return {React.JSX.Element|null} タブのJSX要素
   */
  renderCondition() {
    const {classes} = this.props;

    return (
      <React.Fragment>
        <Grid
          container
          justifyContent="flex-start"
          alignItems="flex-start"
          spacing={1}
          direction={'row'}
        >

          <Grid key="keySCZ1005SurveyCompanyCode" item xs={12} sm={2}>
            <Field
              id="surveyCompanyCode"
              name="surveyCompanyCode"
              component={renderSelect}
              className="fields"
              label="調査会社"
              fullWidth
              required={false}
              validate={[
              ]}
              InputProps={{
                readOnly: false,
              }}
            >
              {this.surveyCompanyCodeList}
            </Field>
          </Grid>
          <Grid key="keySCZ1005NwOfficeCode" item xs={12} sm={2}>
            <Field
              id="nwOfficeCode"
              name="nwOfficeCode"
              component={renderSelect}
              className="fields"
              label="NW事業所"
              fullWidth
              required={false}
              validate={[
              ]}
              InputProps={{
                readOnly: false,
              }}
            >
              {this.nwOfficeList}
            </Field>
          </Grid>
          <Grid key="keySCZ1005SurveyAgencyOfficeCode" item xs={12} sm={2}>
            <Field
              id="surveyAgencyOfficeCode"
              name="surveyAgencyOfficeCode"
              component={renderSelect}
              className="fields"
              label="調査機関事業所"
              fullWidth
              required={false}
              validate={[
              ]}
              InputProps={{
                readOnly: false,
              }}
            >
              {this.surveyAgencyOfficeCodeList}
            </Field>
          </Grid>
          <Grid key="keySCZ1005WaitSelfApproval" item xs={12} sm={3}>
            <FormControl component="fieldset" className={classes.formControl}>
              <FormGroup row={true}>
                <Field className={classes.checkbox}
                  id="waitSelfApproval"
                  name="waitSelfApproval"
                  component={renderCheckbox}
                  label="承認待ち（自分のみ）"
                  onChange={this._handleChangeCheckboxApproval}
                  validate={[]}
                  sx={{marginLeft: '20px'}}
                />
              </FormGroup>
            </FormControl>
          </Grid>

        </Grid>
        <Grid
          container
          justifyContent="flex-start"
          alignItems="flex-start"
          spacing={1}
          direction={'row'}
        >

          <Grid key="keySCZ1005ApprovalRecordType" item xs={12} sm={2}>
            <Field
              id="approvalRecordType"
              name="approvalRecordType"
              component={renderSelect}
              className="fields"
              label="承認区分"
              fullWidth
              required={false}
              validate={[
              ]}
              InputProps={{
                readOnly: false,
              }}
            >
              {this.approvalRecordTypeList}
            </Field>
          </Grid>
          <Grid key="keySCZ1005StepApproval" item xs={12} sm={2}>
            <Field
              id="stepApproval"
              name="stepApproval"
              component={renderSelectMultiLine}
              className="fields"
              label="承認ステータス"
              fullWidth
              type="text"
              required={false}
              validate={[
              ]}
              InputProps={{
                readOnly: false,
              }}
            >
              {this.stepApprovalList}
            </Field>
          </Grid>
          <Grid key="keySCZ1005AppInfoNo" item xs={12} sm={2}>
            <Field
              id="appInfoNo"
              name="appInfoNo"
              component={renderTextField}
              className="fields"
              label="対象番号"
              fullWidth
              required={false}
              validate={[
              ]}
              InputProps={{
                readOnly: false,
                shrink: true,
              }}
            >
            </Field>
          </Grid>
          <Grid key="keySCZ1005RegisterUser" item xs={12} sm={2}>
            <Field
              id="registerUser"
              name="registerUser"
              component={renderTextField}
              className="fields"
              label="申請者"
              fullWidth
              required={false}
              validate={[
              ]}
              InputProps={{
                readOnly: false,
                shrink: true,
              }}
            >
            </Field>
          </Grid>
          <Grid key="keySCZ1005RegisterDateTime" item xs={12} sm={4}>
            <Field
              id="registerDateTimeFrom"
              name="registerDateTimeFrom"
              component={renderTextField}
              className="fields"
              label="申請日"
              type="date"
              InputLabelProps={{
                shrink: true,
              }}
              validate={[
                validateRule.date,
              ]}
            />
            <span className="wave">～</span>
            <Field
              id="registerDateTimeTo"
              name="registerDateTimeTo"
              component={renderTextField}
              className="fields"
              type="date"
              InputLabelProps={{
                shrink: true,
              }}
              validate={[
                validateRule.date,
              ]}
            />
          </Grid>
        </Grid>
      </React.Fragment>
    );
  };

  render() {
    const {
      classes,
      handleSubmit,
    } = this.props;
    return (
      <form noValidate autoComplete="off" className={classes.root}>
        <MainContainer
          props={this.props}
        >
          <Grid key="keySCZ1005Msg" item xs={12}>
            <WarningMessageArea messages={this.state.warningMessages}/>
          </Grid>
          <CustomBreadcrumbs key="keySCZ1005Breadcrumbs" items={transitionList}/>
          <PaperPart>
            <Grid key="keySCZ1005SearchCondition" item xs={12}>
              <CustomAccordion title='検索条件' items={[this.renderCondition()]} defaultExpanded={true} />
            </Grid>
            <Grid
              container
              justifyContent="right"
              alignItems="right"
              spacing={1}
            >
              <Grid key="keySCZ1005Clear" item>
                <NegativeButton
                  id="clear"
                  startIcon={<RotateLeftIcon />}
                  className="button_list"
                  onClick={this._reset}
                >
                  <span>クリア</span>
                </NegativeButton>
              </Grid>
              <Grid key="keySCZ1005Search" item>
                <PositiveButton
                  id="search"
                  variant="contained"
                  startIcon={<SearchIcon />}
                  className="button_list"
                  onClick={handleSubmit(this.doSearch)}
                >
                  <span>検索</span>
                </PositiveButton>
              </Grid>
            </Grid>
          </PaperPart>
          <div style={{marginBottom: '20px'}} />
          <Divider variant="middle" />
          <div style={{marginBottom: '20px'}} />
          <Grid container
            justifyContent="flex-start"
            alignItems="flex-start"
          >
            <Grid key="keySCZ1005List" item xs={12}>
              {this.renderTable()}
            </Grid>
          </Grid>
        </MainContainer>
        {this.state.showApprovalModal && <ApprovalStatus
          openState={this.state.showApprovalModal}
          handleClose = {this.closeApproval}
          appInfoNoList={this.state.appInfoNoList}/>
        }
      </form>
    );
  }
}

Container.propTypes = {
  classes: PropTypes.object,
  genericMap: PropTypes.object,
  history: PropTypes.object,
  values: PropTypes.object,
  userInfo: PropTypes.object,
  reset: PropTypes.func,
  handleSubmit: PropTypes.func,
  doShowMessage: PropTypes.func,
  doSetInitValues: PropTypes.func,
  navigate: PropTypes.func,
};

const mapStateToProps = (state) => {
  return {
    genericMap: state.common.generalPurposeMap,
    userInfo: state.auth.userInfo,
    initialValues: state.common.setInitValues,
  };
};

const mapDispatchToProps = {
  doShowMessage: commonOperations.doShowMessage,
  doSetInitValues: commonOperations.doSetInitValues,
};

const FORM_NAME = 'SCZ1005FORM';

Container = reduxForm({
  form: FORM_NAME,
  destroyOnUnmount: false,
  enableReinitialize: true,
  validate: validate,
})(connect((state) => {
  return {
    values: getFormValues(FORM_NAME)(state),
  };
})(Container));

export default withStyles()(
    connect(
        mapStateToProps,
        mapDispatchToProps,
    )(withRouter(Container)),
);
